import { WebAppServiceWorker } from './register';

const serviceWorker = new WebAppServiceWorker();

export function useServiceWorker() {
	return serviceWorker;
}
